// extracted by mini-css-extract-plugin
export default {"container":"_5fZYx8XWdbV6PdHdtT8ROw","icon":"_2YZw5SwLobWX8SSHJ3hnnR"};